module.exports = __webpack_public_path__ + "img/topics3.d0df750d.jpg";